import { AxiosPromise } from 'axios';
import { CrudService } from './CrudService';
import { Args, AxiosConfig } from './BaseService';
import { resources } from '../resources';
import { EmployeeQueryParams } from '../params/EmployeeQueryParams';
import { EmployeeDto } from '../models/employees/EmployeeDto';
import { ReferenceDto } from '../models/employees/ReferenceDto';
import { CreateUserFromEmployeeRequest } from '../models/user/CreateUserFromEmployeeRequest';

export class EmployeeService extends CrudService<EmployeeDto, EmployeeQueryParams> {
  constructor() {
    super({
      query: resources.queryEmployees,
      get: resources.getEmployee,
      create: resources.createEmployee,
      update: resources.updateEmployee,
      idKey: 'employeeId',
    });
  }

  public createUser(employeeId: string, body: CreateUserFromEmployeeRequest, args?: Args, options?: AxiosConfig): AxiosPromise<ReferenceDto> {
    return this.post<ReferenceDto>(resources.createUser, body, { employeeId, ...args }, options);
  }

  public importEmployees(file: File, args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.put<void>(resources.importEmployees, formData, args, {
      headers: { 'Content-Type': 'multipart/form-data' },
      ...options,
    });
  }

  public exportEmployees(args?: Args, options?: AxiosConfig): AxiosPromise<Blob> {
    return this.get<Blob>(resources.exportEmployees, { responseType: 'blob', ...args }, options);
  }
}
